import _ from 'lodash';

const getOrderTypeConfig = (dispensary, orderType) => {
  if (!dispensary || !orderType) {
    return null;
  }

  const { orderTypesConfigV2 } = dispensary;
  const formattedOrderType = orderType === 'pickup' ? 'inStorePickup' : orderType;

  return orderTypesConfigV2?.[formattedOrderType] ?? null;
};

export const getCustomCheckoutMessage = (dispensary, orderType) =>
  getOrderTypeConfig(dispensary, orderType)?.checkoutMessage ?? null;

export const getCreditCardByPhoneCheckoutMessage = (dispensary, orderType) =>
  getOrderTypeConfig(dispensary, orderType)?.creditCardByPhoneCheckoutMessage ?? null;
